import * as tslib_1 from "tslib";
import * as store from "store";
import moment from "moment";
import { each } from "lodash";
import { injectable } from "./../Di";
let CacheService = class CacheService {
    /**
     * @param store
     */
    constructor(storeInstance = store) {
        this.storeInstance = storeInstance;
        /**
         * @type {boolean}
         */
        this.debug = false;
        /**
         * @type {boolean}
         */
        this.enabled = false;
        if (!this.storeInstance) {
            throw new Error("`store` cannot be found");
        }
    }
    /**
     * @returns {boolean}
     */
    canCache() {
        return this.storeInstance.enabled && this.enabled;
    }
    /**
     * @param args
     */
    log(...args) {
        if (!this.debug) {
            return;
        }
        args.forEach(arg => console.log(arg));
    }
    /**
     * @param signature
     * @returns {any|null}
     */
    get(signature) {
        if (!this.canCache()) {
            return;
        }
        this.log('Trying to get item ' + signature);
        var value = this.storeInstance.get(signature);
        if (!value || this.isExpired(value)) {
            this.log('No data found or expired for  ' + signature);
            return null;
        }
        this.log('Got data from cache for  ' + signature, JSON.parse(value.value));
        return JSON.parse(value.value);
    }
    /**
     * @returns {void}
     */
    clear() {
        this.log('Cache cleared');
        this.storeInstance.clear();
    }
    /**
     * @returns {boolean}
     */
    debugEnabled() {
        return this.debug;
    }
    /**
     * @param tag
     * @returns {Array}
     */
    getByTag(tag) {
        this.log('Get item by tag: ' + tag);
        var items = [];
        each(this.storeInstance.getAll(), (item) => {
            if (-1 !== item.tags.includes(tag)) {
                if (!this.isExpired(item)) {
                    items.push(JSON.parse(item.value));
                }
            }
        });
        this.log('Got items by tag: ' + tag, items);
        return items;
    }
    /**
     * @param tag
     */
    clearByTag(tag) {
        this.log('Clear items by tag: ' + tag);
        each(this.storeInstance.getAll(), (item, offset) => {
            if (-1 !== item.tags.includes(tag)) {
                this.remove(offset);
            }
        });
        this.log('Cleared items by tag: ' + tag);
    }
    /**
     * @param signature
     */
    remove(signature) {
        this.log('Removing item ' + signature);
        this.storeInstance.remove(signature);
    }
    /**
     * @param tags
     */
    clearByTags(tags) {
        this.log('Clear items by tags: ' + tags.join(', '));
        each(this.storeInstance.getAll(), (item, offset) => {
            each(tags, (tag) => {
                if (-1 !== item.tags.includes(tag)) {
                    this.remove(offset);
                }
            });
        });
        this.log('Cleared items by tags: ' + tags.join(', '));
    }
    /**
     * @returns {void}
     */
    enableDebug() {
        this.debug = true;
        this.log('Cache debug enabled');
        if (!this.storeInstance.enabled) {
            this.log('Cache is disabled due to browser');
        }
        else {
            if (this.enabled) {
                this.log('Cache is enabled');
            }
            else {
                this.log('Cache is disabled due to settings');
            }
        }
    }
    /**
     * @returns {void}
     */
    disable() {
        this.enabled = false;
        this.log('Cache is disabled due to settings');
    }
    /**
     * @returns {boolean}
     */
    isEnabled() {
        return this.enabled;
    }
    /**
     * @returns {void}
     */
    enable() {
        this.enabled = true;
        this.log('Cache enabled');
    }
    /**
     * @param name
     * @param value
     * @param expiration
     * @param forcedExpiration
     * @param tags
     */
    set(name, value, expiration, forcedExpiration, tags) {
        if (!expiration) {
            expiration = 0;
        }
        if (!forcedExpiration) {
            forcedExpiration = 0;
        }
        if (!this.canCache()) {
            return;
        }
        var expirationDate = expiration ? moment().add(expiration, 'seconds') : 0;
        var forcedExpirationDate = forcedExpiration ? moment().add(forcedExpiration, 'seconds') : 0;
        this.log('Setting item into cache ' + name + ' with expiration date: ' + (expirationDate ? expirationDate.format('YYYY-MM-DD HH:mm:ss') : 'never') + ' and a forced expiration date: ' + (forcedExpirationDate ? forcedExpirationDate.format('YYYY-MM-DD HH:mm:ss') : 'never'), value);
        var item = {
            name: name,
            value: JSON.stringify(value),
            expiration: expirationDate !== 0 ? expirationDate.unix() : expirationDate,
            forcedExpirationDate: forcedExpirationDate !== 0 ? forcedExpirationDate.unix() : forcedExpirationDate,
            tags: tags ? tags : []
        };
        this.storeInstance.set(name, item);
    }
    /**
     * @param item
     * @returns {boolean}
     */
    isExpired(item) {
        if (item.forcedExpirationDate != 0 && item.forcedExpirationDate < moment().unix()) {
            this.log('Item ' + item.name + ' is expired.');
            this.remove(item.name);
            return true;
        }
        if (item.expiration != 0 && item.expiration < moment().unix()) {
            this.log('Item ' + item.name + ' is expired but can still use it for now.');
            this.remove(item.name);
        }
        return false;
    }
};
CacheService = tslib_1.__decorate([
    injectable,
    tslib_1.__metadata("design:paramtypes", [Object])
], CacheService);
export { CacheService };
